
interface ContactNameParts {
  fullName?: string | null;
  contactName?: string | null;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  email?: string | null;
}


export const contactDisplayName = (contact: ContactNameParts): string =>
  contact.fullName?.trim() ||
  contact.contactName?.trim() ||
  [contact.firstName, contact.middleName, contact.lastName]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(" ") ||
  contact.email?.trim() ||
  "";
